"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.genericGraphQLErrorsHandler = exports.isQueryRefetching = exports.isQueryLoadingOrRefetching = exports.isQueryInitialLoading = exports.isQueryUpdating = exports.isQueryLoading = void 0;
const client_1 = require("@apollo/client");
// query is loading for the first time or due to variables change
const isQueryLoading = (status) => [client_1.NetworkStatus.loading, client_1.NetworkStatus.setVariables].includes(status);
exports.isQueryLoading = isQueryLoading;
// query is triggered by variables change
const isQueryUpdating = (status) => status === client_1.NetworkStatus.setVariables;
exports.isQueryUpdating = isQueryUpdating;
const isQueryInitialLoading = (status) => status === client_1.NetworkStatus.loading;
exports.isQueryInitialLoading = isQueryInitialLoading;
const isQueryLoadingOrRefetching = (status) => [
    client_1.NetworkStatus.loading,
    client_1.NetworkStatus.setVariables,
    client_1.NetworkStatus.refetch,
].includes(status);
exports.isQueryLoadingOrRefetching = isQueryLoadingOrRefetching;
const isQueryRefetching = (status) => status === client_1.NetworkStatus.refetch;
exports.isQueryRefetching = isQueryRefetching;
const genericGraphQLErrorsHandler = (response) => {
    var _a, _b, _c, _d, _e;
    const apolloGraphQLErrors = (_b = (_a = response.error) === null || _a === void 0 ? void 0 : _a.graphQLErrors) !== null && _b !== void 0 ? _b : [];
    if (process.env.NODE_ENV !== 'production') {
        const errorExtensions = (_c = response.errors) === null || _c === void 0 ? void 0 : _c.map(({ extensions }) => extensions).filter((extensions) => extensions !== undefined);
        const apolloErrorExtensions = apolloGraphQLErrors
            .map(({ extensions }) => extensions)
            .filter((extensions) => extensions !== undefined);
        if ((errorExtensions === null || errorExtensions === void 0 ? void 0 : errorExtensions.length) || apolloErrorExtensions.length) {
            // eslint-disable-next-line no-console
            console.error('GraphQL extensions:', {
                errorExtensions,
                apolloErrorExtensions,
            });
        }
    }
    const graphQLErrorMessages = [
        ...((_e = (_d = response.errors) === null || _d === void 0 ? void 0 : _d.map(({ message }) => message).filter(Boolean)) !== null && _e !== void 0 ? _e : []),
        ...apolloGraphQLErrors.map(({ message }) => message).filter(Boolean),
    ];
    if (graphQLErrorMessages === null || graphQLErrorMessages === void 0 ? void 0 : graphQLErrorMessages.length) {
        throw new Error(graphQLErrorMessages.join('; '));
    }
    if (response.error) {
        throw response.error;
    }
};
exports.genericGraphQLErrorsHandler = genericGraphQLErrorsHandler;
